import { ProtectedRoute } from '../../../router/protectedrouter';

import MainLayout from '../../../components/layouts/MainLayoutPage';
import ViewAgents from '../components/ViewAgents';
import Dashboard from '../components/Dashboard';
import ThreatHuntingAlerts from '../components/ThreatHuntingAlerts';
import SecurityAlerts from '../components/SecurityAlerts';
import ViewSecurityAlert from '../components/ViewSecurityAlert';
import ViewMitreData from '../components/ViewMitreData';
import ViewVulnerabilityData from '../components/ViewVulnerabilityData'
import SCAReport from '../components/SCAReport';
import ViewSCAReportData from '../components/ViewSCAReportData';
import ViewFIMData from '../components/ViewFIMData';
import ViewMalwareDetails from '../components/ViewMalwareDetails';
import MalwareDetectionGraph from '../components/MalwareDetectionGraph';
import OverallDashboard from '../components/OverallDashboard';
import ReportManagement from '../components/ReportManagement';
import DownloadSOCReport from '../components/DownloadReport';

const base_url="/soc";
const routes = [
    {
        path: `${base_url}`,
        children:[
            {
                path: `view-agents`,
                element: <ProtectedRoute><MainLayout> <ViewAgents/> </MainLayout></ProtectedRoute>,
                name: "view-agents",
            },
            {
                path: `dashboard`,
                element: <ProtectedRoute><MainLayout> <Dashboard/> </MainLayout></ProtectedRoute>,
                name: "dashboard",
            },
            {
                path: `threat-hunting`,
                element: <ProtectedRoute><MainLayout> <ThreatHuntingAlerts/> </MainLayout></ProtectedRoute>,
                name: "dashboard",
            },
            {
                path: `security-alerts`,
                element: <ProtectedRoute><MainLayout> <SecurityAlerts/> </MainLayout></ProtectedRoute>,
                name: "security-alerts",
            },
            {
                path: `view-security-alert`,
                element: <ProtectedRoute><MainLayout> <ViewSecurityAlert/> </MainLayout></ProtectedRoute>,
                name: "view-security-alert",
            },
            {
                path: `mitre-dashboard`,
                element: <ProtectedRoute><MainLayout> <ViewMitreData/> </MainLayout></ProtectedRoute>,
                name: "mitregraph",
            },
            {
                path: `vulnerability-data`,
                element: <ProtectedRoute><MainLayout> <ViewVulnerabilityData/> </MainLayout></ProtectedRoute>,
                name: "vulnerability-data",
            },
            {
                path:`sca-report`,
                element:<ProtectedRoute><MainLayout><SCAReport></SCAReport></MainLayout></ProtectedRoute>,
                name:"scareport",
            },
            {
                path:`view-sca-report`,
                element:<ProtectedRoute><MainLayout><ViewSCAReportData></ViewSCAReportData></MainLayout></ProtectedRoute>
            },
            {
                path:`fim-data`,
                element:<ProtectedRoute><MainLayout><ViewFIMData/></MainLayout></ProtectedRoute>
            },
            {
                path:`malware-data`,
                element:<ProtectedRoute><MainLayout><ViewMalwareDetails/></MainLayout></ProtectedRoute>
            },
            {
                path:`malware-graph`,
                element:<ProtectedRoute><MainLayout><MalwareDetectionGraph/></MainLayout></ProtectedRoute>
            },
            {
                path:`overall-dashboard`,
                element:<ProtectedRoute><MainLayout><OverallDashboard/></MainLayout></ProtectedRoute>
            },       
            {
                path:`report-management`,
                element: <ProtectedRoute><MainLayout><ReportManagement/></MainLayout></ProtectedRoute>
            },
            {
                path:`download-report`,
                element:<ProtectedRoute><MainLayout><DownloadSOCReport/></MainLayout></ProtectedRoute>
            }
        ]
    },
]


export default routes;